import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/app/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/app/src/app/context/NotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/context/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/src/app/context/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
